import { LockScroll } from './LockScroll.js';

/*
    Видео в попапе
*/

let videoObj;

export class Video {
    constructor() {
        this.videoDuration;
        this.$progressBar = App.H.find('.js-video-progress');
        this.$progressLine = App.H.find('.js-video-progress-line');
        this.$progressBuffer = App.H.find('.js-video-progress-buffer');
        this.$videoContainer = App.H.find('.js-video-container');
        this.$buttonMute = App.H.find('.js-video-mute');
        this.lockScroll = new LockScroll;

        this.popupFlag = false;
        this.popupIsOpen = false;

        this.bindVimeoControls();
        this.bindPopupControls();
        this.bindTabEvents();
    }



    // Плеер Vimeo
    initVimeo(id) {
        this.player = new Vimeo.Player('video', {
            id: id,
            // autoplay: this.isSmartphone() ? false : true,
            autoplay: App.mobile ? false : true,
            autopause: false,
            controls: this.isSmartphone() ? true : false,
            loop: false,
            transparent: false,
            playsinline: false
        });

        // Сбрасываем mute при открытии popup

        this.player.setMuted(false);
        this.$buttonMute.removeClass('_muted');
        sessionStorage.setItem('videomuted', 0);

        /*
            У Vimeo сквозной параметр громкости на всех сайтах:
            если изменить на одном, сразу изменится во всех
            вкладках браузера. У нас нет контролов громкости
            на планшетах и телефонах, поэтому принудительно
            задаём громкость при открытии видео:
        */

        if (!this.isSmartphone()) {
            this.player.setVolume(0.75);
        }


        // Запоминаем длительность видео
        this.player.getDuration().then((duration) => {
            this.videoDuration = duration;
        });


        // Прогресс-бар
        this.player.on('timeupdate', (data) => {
            this.$progressLine.css({
                width: `${data.percent * 100}%`
            });
        });


        // Буфферизация
        this.player.on('progress', (data) => {
            this.$progressBuffer.css({
                width: `${data.percent * 100}%`
            });
        });


        /* Прячем кнопку Play для плашнетов поверх видео
            (Она нужна, потому что автоплей не работает,
            а стандартные контролы Vimeo отключены) */
        this.player.on('play', () => {
            this.$videoContainer.addClass('_playing');
        });
    }



    // Уничтожаем Vimeo
    destroyVimeo() {
        try {
            this.player.destroy();
        } catch (error) { }

        this.$videoContainer.html('');
        this.player = false;
    }



    // Кастомные контролы Vimeo
    bindVimeoControls() {
        App.H.off('.vimeo');

        // Mute
        {
            this.$buttonMute.on('click', () => {

                this.player.getMuted().then((muted) => {

                    if (muted) {
                        this.player.setMuted(false);
                        this.$buttonMute.removeClass('_muted');
                        sessionStorage.setItem('videomuted', 0);
                    } else {
                        this.player.setMuted(true);
                        this.$buttonMute.addClass('_muted');

                        /* Запоминаем параметр, чтобы в следующий раз
                        открыть видео уже без звука */
                        sessionStorage.setItem('videomuted', 1);
                    }
                });

            });
        }


        // Pause/Play
        App.H.on('click.vimeo', '.js-video-pause', () => {
            this.player.getPaused().then((paused) => {
                if (paused) {
                    this.player.play();
                    /*if (this.isSmartphone()) {
                        this.$videoContainer.find('iframe')[0].webkitRequestFullScreen();
                    }*/
                } else {
                    this.player.pause();
                }
            });
        });


        // Перемотка кликом по прогресс-бару
        App.H.on('click.vimeo', '.js-video-progress', (e) => {
            // Координаты клика в пикселях
            const x = e.pageX - this.$progressBar.offset().left;

            // Координаты клика в пропорции
            const p = x / this.$progressBar.width();

            // Координаты клика в секундах
            const s = this.videoDuration * p;

            this.player.setCurrentTime(s);
        });
    }



    // Открытие и закрытие попапа
    bindPopupControls() {
        // Открыть
        App.H.on('click.video', '.js-video', (e) => {
            e.preventDefault();
            const id = $(e.target).closest('.js-video').data('id');
            const ratio = $(e.target).closest('.js-video').data('ratio');

            if (id) {
                this.openPopup(id, ratio);
            }
        });


        // Закрыть
        App.H.on('click.video', '.js-close-video', () => {
            this.closePopup();
        });


        // Закрыть клавишей Escape
        App.W.on('keydown.video', (e) => {
            if (this.popupIsOpen && e.keyCode === 27) {
                this.closePopup();
            }
        });
    }



    // Открываем попап
    openPopup(id, ratio) {
        if (this.popupFlag) { return; }
        this.popupFlag = true;
        this.popupIsOpen = true;


        // Подставляем правильные пропорции для видео
        {
            let h = 0.5625;   // По умолчанию соотношение 16:9 = 56,25%

            if (ratio) {
                try {
                    // Если указаны пропорции, считаем высоту
                    const r = ratio.split(':');
                    h = r[1] / r[0];
                } catch (error) {}
            }

            App.H.find('.js-video-popup-video').css({
                'padding-top': h * 100 + '%'
            });
        }


        // Открываем попап
        App.H.addClass('_video-open');

        setTimeout(() => {
            this.lockScroll.lock();
        }, 500);


        // Запускаем видео чере паузу, чтобы не тормозило
        setTimeout(() => {
            this.popupFlag = false;
            this.initVimeo(id);
        }, 1000);


        // Ставим фокус на первую ссылку (для Tab-навигации)
        if (!App.mobile) {
            setTimeout(() => {
                App.H.find('.js-video-popup').find('button:eq(0)').focus();
            }, 500);
        }
    }



    // Закрываем попап
    closePopup() {
        if (this.popupFlag) return;
        this.popupFlag = true;


        this.destroyVimeo();

        this.$progressLine
            .add(this.$progressBuffer)
            .css({
                width: 0
            });

        this.$videoContainer.removeClass('_playing');


        App.H.removeClass('_video-open');


        setTimeout(() => {
            this.lockScroll.unlock();
            this.popupFlag = false;
        }, 300);

        setTimeout(() => {
            this.popupFlag = false;
        }, 1000);

        this.popupIsOpen = false;


        // Возвращаем фокус на бургер (для Tab-навигации)
        /*if (!App.mobile) {
            $('.js-burger').focus();
        }*/
    }



    // Ставим видео на паузу при уходе с вкладки браузера
    bindTabEvents() {

        // Уходим
        App.W.on('tableave', () => {
            if (this.player) {
                this.player.getPaused().then((paused) => {
                    if (!paused) {
                        this.player.pause();

                        // Запоминаем, что принудительно поставили на паузу
                        this.player.forcePause = true;
                    }
                });
            }
        });

        // Возвращаемся
        App.W.on('tabenter', () => {
            if (this.player) {
                this.player.getPaused().then((paused) => {

                    /* Проверяем, что на паузе именно из-за ухода с вкладки,
                    чтобы не стартовать видео, которое пользователь сам остановил */
                    if (paused && this.player.forcePause) {
                        this.player.play();
                        this.player.forcePause = false;
                    }
                });
            }
        });
    }



    destroy() {
        destroyVimeo();

        App.H.off('.vimeo');
        App.H.off('.video');
    }



    isSmartphone() {
        return App.H.width() < 768;
    }
}



App.W.on('barba:afterEnter', () => {
    videoObj = new Video();
    
    if ($("video[autoplay]").length) {
        $("video[autoplay]").each(function() { 
            this.play(); 
        });
    }
});

App.W.on('barba:leave', () => {
    try {
        videoObj.destroy();
    } catch(error) { }
});



// WEBPACK FOOTER //
// ./_src/js/modules/Video.js